<template>
  <div class="home">
    <div class="park">
      <div class="park-title">
        <img
          src="../assets/home/parkTitle.png"
          style="width: 766px; height: 91px"
        />
      </div>
      <div class="park-content">
        <div
          class="content-left"
          style="position: relative; cursor: pointer"
          @click="goInfo(parkData[0].noticeId, 'park')"
        >
          <img
            :src="parkData[0].pImage"
            style="width: 490px; height: 460px; position: relative"
          />
          <span
            style="
              position: absolute;
              bottom: 18px;
              left: 13px;
              font-size: 18px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #ffffff;
              text-overflow: -o-ellipsis-lastline;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              line-clamp: 1;
              -webkit-box-orient: vertical;
            "
            >{{ parkData[0].title }}</span
          >
        </div>
        <div class="content-right">
          <div
            style="display: flex; cursor: pointer"
            @click="goInfo(parkData[1].noticeId, 'park')"
          >
            <div
              style="width: 48px;height: 27px;line-height: 27px; background: linear-gradient(90deg, #D1913C, #FFD194);border-radius: 4px;font-size: 16px;text-align:center
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #FFFFFF;"
            >
              要闻
            </div>
            <span
              style="
                margin-left: 16px;
                font-size: 20px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #333333;
              "
              >{{ parkData[1].title }}</span
            >
          </div>
          <div
            style="
              font-size: 16px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #9e9e9e;
              line-height: 30px;
              padding: 23px 0;
              border-bottom: 1px solid #e6e6e6;
              cursor: pointer;
            "
            @click="goInfo"
          >
            {{ parkData[1].noticeDesc }}
          </div>
          <div v-for="i in parkDatas" :key="i.noticeId">
            <div
              @click="goInfo(i.noticeId, 'park')"
              style="
                line-height: 42px;
                display: flex;
                justify-content: space-between;
                font-family: Microsoft YaHei;
                font-weight: 400;
                cursor: pointer;
              "
            >
              <div
                style="color: #333333; font-size: 18px; width: 433px"
                class="over"
              >
                {{ i.title }}
              </div>
              <div style="color: #9e9e9e; font-size: 16rpx">
                {{ i.createTime }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="service">
      <div class="service-title">
        <img
          src="../assets/home/serviceTitle.png"
          style="width: 698px; height: 91px"
        />
      </div>
      <div class="service-content">
        <div
          class="content"
          style="
            display: flex;
            justify-content: space-between;
            margin-top: 52px;
          "
        >
          <div v-for="i in service" :key="i.title">
            <div>
              <img :src="i.img" style="width: 380px; height: 240px" />
            </div>
            <div
              style="
                text-align: center;
                margin-top: 34px;
                font-size: 30px;
                font-family: FZZhunYuan-M02S;
                font-weight: 400;
                color: #000000;
              "
            >
              {{ i.title }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="policy">
      <div class="policy-title">
        <img
          src="../assets/home/policy.png"
          style="width: 709px; height: 91px"
        />
      </div>
      <div class="policyBox">
        <div class="policy-content">
          <div
            class="policy-bg"
            style="position: relative; cursor: pointer"
            @click="policyMore"
          >
            <img
              src="../assets/home/policy-bg.png"
              style="width: 198px; height: 484px"
            />
            <div
              style="
                width: 90px;
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #e50f0f;
                height: 29px;
                background: #fffbcf;
                border-radius: 15px;
                position: absolute;
                left: 57px;
                bottom: 58px;
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              更多>>
            </div>
          </div>
          <div class="content">
            <div class="content-box" v-for="i in policyData" :key="i.noticeId">
              <div
                @click="goInfo(i.noticeId, 'policy')"
                style="cursor: pointer"
              >
                <div
                  style="
                    font-size: 20px;
                    font-family: Microsoft YaHei;
                    font-weight: bold;
                    color: #333333;
                    display: flex;
                  "
                >
                  <span>{{ i.createTime }}</span>
                  <span
                    style="
                      margin-left: 28px;
                      text-overflow: -o-ellipsis-lastline;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      display: -webkit-box;
                      -webkit-line-clamp: 2;
                      line-clamp: 2;
                      -webkit-box-orient: vertical;
                    "
                    >{{ i.title }}</span
                  >
                </div>
                <div
                  style="
                    margin-top: 15px;
                    font-size: 16px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #9e9e9e;
                    display: flex;
                    margin-left: 74px;
                    text-overflow: -o-ellipsis-lastline;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    line-clamp: 2;
                    -webkit-box-orient: vertical;
                  "
                >
                  {{ i.noticeDesc }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="kehui">
      <div class="kehui-title">
        <img
          src="../assets/home/kehui.png"
          style="width: 765px; height: 91px"
        />
      </div>
    </div>

    <div class="swiper_box">
      <div class="prev">
        <img :src="leftBtn" alt="" class="swiper-button" @click="clickPrev" />
      </div>
      <div class="swiper_">
        <swiper ref="mySwiper" :options="swiperOptions">
          <swiper-slide
            class="item-device"
            v-for="(item, index) in kehuiDatas"
            :key="index"
          >
            <!-- <div class="device"> -->
            <div class="dev-img" @click="goInfo(item.noticeId, 'kehui')">
              <img
                :src="item.pImage"
                style="width: 224px; height: 300px"
                alt=""
              />
              <div
                style="
                  position: absolute;
                  left: 18px;
                  bottom: 20px;
                  font-size: 16px;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  color: #ffffff;
                "
              >
                <div style="margin-bottom: 11px; width: 188px" class="over">
                  {{ item.title }}
                </div>
                <div>{{ item.createTime }}</div>
              </div>
            </div>
            <!-- </div> -->
          </swiper-slide>
        </swiper>
      </div>
      <div class="next">
        <img :src="rightBtn" alt="" class="swiper-button" @click="clickNext" />
      </div>
    </div>
  </div>
</template>

<script>
import { information } from "../api/home";
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  components: { swiper, swiperSlide },
  data() {
    return {
      swiperOptions: {
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        slidesPerView: "auto",
        freeMode: true,
        spaceBetween: 0,
        history: "love",
        // 设置点击箭头
        navigation: {
          nextEl: ".next",
          prevEl: ".prev",
        },
      },
      leftBtn: require("../assets/home/left.png"), //左边点击按钮图片
      rightBtn: require("../assets/home/right.png"), //右边点击按钮图片

      service: [
        {
          img: require("../assets/home/service1.png"),
          title: "网络货运",
        },
        {
          img: require("../assets/home/service2.png"),
          title: "再生资源",
        },
        {
          img: require("../assets/home/service3.png"),
          title: "信息通讯",
        },
      ],
      parkData: [],
      parkDatas: [],
      policyData: [],
      kehuiDatas: [],
      kehuiData: [],
      parkParams: {
        pageNum: 1,
        pageSize: 10,
        noticeType: 1,
      },
      index: 0,
      length: 0,
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },

  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },
  methods: {
    /* 前一步 */
    clickPrev() {
      const that = this;
      const length = that.kehuiDatas.length;
      if (that.activeBtn <= 0 || length == 0) {
        return false;
      }
    },
    /* 后一步 */
    clickNext() {
      const that = this;
      const length = that.kehuiDatas.length;
      if (that.activeBtn >= length - 1 || length == 0) {
        return false;
      }
    },

    kehuiLeft() {
      //   this.index = this.kehuiDatas.length-1
      //   this.index--
      //  this.length--

      //  this.kehuiData = this.kehuiDatas.slice(this.length,this.index)

      console.log("kehuiLeft", this.index, this.length, this.kehuiData);
    },
    kehuiRight() {
      this.index++;
      this.length++;

      if (this.kehuiDatas.length - this.index >= 5) {
        this.kehuiData = this.kehuiDatas.slice(this.index, this.length);
      } else {
      }
      console.log("kehuiRight", this.index, this.length, this.kehuiData);
    },
    policyMore() {
      this.$router.push({
        name: "policySupport",
      });
    },
    goInfo(noticeId, type) {
      this.$router.push({
        name: "policyInfo",
        params: {
          noticeId: noticeId,
          type: type,
        },
      });
    },
    getKehui() {
      this.parkParams.noticeType = 5;
      information(this.parkParams).then((res) => {
        if (res.code == 200) {
          this.kehuiData = res.data.rows.slice(0, 5);
          this.kehuiDatas = res.data.rows;
          this.length = this.kehuiData.length;
        }
      });
    },
    getPolicy() {
      this.parkParams.noticeType = 4;
      information(this.parkParams).then((res) => {
        if (res.code == 200) {
          res.data.rows.forEach((x) => {
            var date = new Date(x.createTime);
            x.createTime = date.getMonth() + 1 + "/" + date.getDate();
          });
          console.log("new Date()", res.data.rows);
          this.policyData = res.data.rows;
        }
      });
    },
    getPark() {
      information(this.parkParams).then((res) => {
        if (res.code == 200) {
          this.parkData = res.data.rows;
          res.data.rows.forEach((x, index) => {
            if (index == 0 || index == 1) {
            } else {
              this.parkDatas.push(x);
            }
          });
          console.log("aaaaaaaaaaaa", this.parkDatas);
        }
      });
    },
  },
  created() {
    this.getPark();
    this.getPolicy();
    this.getKehui();
  },
};
</script>

<style lang="less" scoped>
.home {
  padding-top: 81px;
  //   padding: 0 280px;
  margin: 0 auto;
  .park {
    width: 1200px;
    margin: 0 auto;
    .park-title {
      text-align: center;
    }
    .park-content {
      display: flex;
      justify-content: space-between;
      margin-top: 83px;
      .content-right {
        margin-left: 45px;
      }
    }
  }
  .service {
    width: 1200px;
    margin: 0 auto;
    margin-top: 127px;
    .service-title {
      text-align: center;
    }
  }
  .policy {
    width: 1200px;
    margin: 0 auto;
    padding: 0px 0px;
    margin-top: 192px;

    .policy-title {
      text-align: center;
      margin-bottom: 61px;
    }
    .policyBox {
      // border: 1px dashed #ccc;
      // background: #fafafa;
      background: url("../assets/home/policybg.png");
      padding: 97px 0;

      .policy-content {
        width: 1200px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;

        .content {
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          margin-left: 19px;

          .content-box {
            background: #fff;
            padding: 19px 30px;
            flex: 0 0 40%;
            margin: 0 22px 22px 0px;
          }
        }
      }
    }
  }

  .swiper_box {
    // padding: 0px 278px 197px 278px;
    width: 1200px;
    padding-bottom: 197px;
    // padding:0 278px;
    background: #fff;
    // margin-top: 95px;
    //   margin-bottom: 197px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    // height: 300px;
    justify-content: space-between;
    > div {
      display: inline-block;
      vertical-align: middle;
    }
    .swiper-button {
      width: 42px;
      height: 42px;
      cursor: pointer;
      text-align: center;
      padding: 0;
      font-weight: 500;
    }
    .swiper_ {
      width: 1200px;
      // margin: 0 30px;
      // display: flex;
      .swiper-container {
        height: 300px;
        padding: 0px 20px;
      }

      .item-device {
        width: 240px;
        // .device {
        //   display: flex;
        .dev-img {
          // width: 70px;
          // height: 70px;
          position: relative;
          cursor: pointer;
        }
        // }
      }
    }
  }

  .kehui {
    width: 1200px;
    margin: 0 auto;
    // padding: 0 278px;
    margin-top: 95px;
    // margin-bottom: 197px;

    .kehui-title {
      text-align: center;
      margin-bottom: 82px;
    }
    .kehui-content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .content-content {
        display: flex;
        width: 1200px;

        justify-content: space-between;
      }
    }
  }
  //公共样式
  img {
    width: 100%;
    height: 100%;
  }
  // 溢出隐藏
  .over {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
}
</style>